"use client";

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';
export default function Footer() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const footerLinks = {
      platform: [{
        label: "Browse Courses",
        href: "/courses"
      }, {
        label: "How It Works",
        href: "#how-it-works"
      }, {
        label: "Success Stories",
        href: "#testimonials"
      }, {
        label: "Pricing",
        href: "/pricing"
      }],
      students: [{
        label: "Sign Up",
        href: "/signup"
      }, {
        label: "Student Dashboard",
        href: "/dashboard"
      }, {
        label: "Leaderboard",
        href: "/leaderboard"
      }, {
        label: "Certificates",
        href: "/certificates"
      }],
      companies: [{
        label: "Post Opportunities",
        href: "/companies/post"
      }, {
        label: "Find Talent",
        href: "/companies/talent"
      }, {
        label: "Partner With Us",
        href: "/companies/partner"
      }, {
        label: "Company Login",
        href: "/companies/login"
      }],
      resources: [{
        label: "Blog",
        href: "/blog"
      }, {
        label: "Help Center",
        href: "/help"
      }, {
        label: "Career Guide",
        href: "/career-guide"
      }, {
        label: "API Documentation",
        href: "/api"
      }],
      company: [{
        label: "About Us",
        href: "/about"
      }, {
        label: "Careers",
        href: "/careers"
      }, {
        label: "Press Kit",
        href: "/press"
      }, {
        label: "Contact",
        href: "/contact"
      }],
      legal: [{
        label: "Privacy Policy",
        href: "/privacy-policy"
      }, {
        label: "Terms of Service",
        href: "/terms"
      }, {
        label: "Cookie Policy",
        href: "/cookies"
      }, {
        label: "Refund Policy",
        href: "/refund"
      }]
    };
    const socialLinks = [{
      icon: Facebook,
      href: "https://facebook.com",
      label: "Facebook"
    }, {
      icon: Twitter,
      href: "https://twitter.com",
      label: "Twitter"
    }, {
      icon: Linkedin,
      href: "https://linkedin.com",
      label: "LinkedIn"
    }, {
      icon: Instagram,
      href: "https://instagram.com",
      label: "Instagram"
    }];
    t0 = <footer className="bg-gray-900 text-gray-300"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16"><div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-12"><div className="col-span-2 md:col-span-3 lg:col-span-2"><Link href="/" className="flex items-center mb-4"><div className="relative w-36 h-12"><Image src="/logo.svg" alt="Learn 2 Link" fill={true} className="object-contain" /></div></Link><p className="text-gray-400 mb-6 max-w-sm">Empowering the next generation of professionals through innovative learning, competition, and career opportunities.</p><div className="space-y-3 mb-6"><div className="flex items-center gap-3 text-sm"><Mail className="w-4 h-4 text-[#6059f7]" /><a href="mailto:contact@learn2link.com" className="hover:text-white transition-colors">contact@learn2link.com</a></div><div className="flex items-center gap-3 text-sm"><Phone className="w-4 h-4 text-[#6059f7]" /><a href="tel:+21650082878" className="hover:text-white transition-colors">+216 50 082 878</a></div><div className="flex items-center gap-3 text-sm"><MapPin className="w-4 h-4 text-[#6059f7]" /><span>Ezzahra, 2034</span></div></div><div className="flex gap-3">{socialLinks.map(_temp)}</div></div><div><h3 className="text-white font-bold mb-4">Platform</h3><ul className="space-y-3">{footerLinks.platform.map(_temp2)}</ul></div><div><h3 className="text-white font-bold mb-4">For Students</h3><ul className="space-y-3">{footerLinks.students.map(_temp3)}</ul></div><div><h3 className="text-white font-bold mb-4">For Companies</h3><ul className="space-y-3">{footerLinks.companies.map(_temp4)}</ul></div><div><h3 className="text-white font-bold mb-4">Resources</h3><ul className="space-y-3">{footerLinks.resources.map(_temp5)}</ul></div></div><div className="border-t border-gray-800 pt-8 mb-8"><div className="max-w-md mx-auto text-center"><h3 className="text-white font-bold text-xl mb-2">Stay Updated</h3><p className="text-gray-400 mb-4 text-sm">Get the latest courses, opportunities, and career tips delivered to your inbox.</p><div className="flex gap-2"><input type="email" placeholder="Enter your email" className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#6059f7]" /><button className="px-6 py-3 bg-[#6059f7] text-white rounded-lg font-semibold hover:bg-[#4e49d4] transition-all whitespace-nowrap">Subscribe</button></div></div></div><div className="border-t border-gray-800 pt-8"><div className="flex flex-col md:flex-row justify-between items-center gap-4"><div className="text-sm text-gray-400">© {new Date().getFullYear()} Learn2Link. All rights reserved.</div><div className="flex flex-wrap justify-center gap-6 text-sm">{footerLinks.legal.map(_temp6)}</div></div></div></div></footer>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp6(link_3, index_4) {
  return <Link key={index_4} href={link_3.href} className="text-gray-400 hover:text-white transition-colors">{link_3.label}</Link>;
}
function _temp5(link_2, index_3) {
  return <li key={index_3}><Link href={link_2.href} className="text-sm hover:text-white transition-colors">{link_2.label}</Link></li>;
}
function _temp4(link_1, index_2) {
  return <li key={index_2}><Link href={link_1.href} className="text-sm hover:text-white transition-colors">{link_1.label}</Link></li>;
}
function _temp3(link_0, index_1) {
  return <li key={index_1}><Link href={link_0.href} className="text-sm hover:text-white transition-colors">{link_0.label}</Link></li>;
}
function _temp2(link, index_0) {
  return <li key={index_0}><Link href={link.href} className="text-sm hover:text-white transition-colors">{link.label}</Link></li>;
}
function _temp(social, index) {
  return <a key={index} href={social.href} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-[#6059f7] transition-colors" aria-label={social.label}><social.icon className="w-5 h-5" /></a>;
}